export default "__VITE_PUBLIC_ASSET__b5096440__"